import { render, staticRenderFns } from "./CreateGiftWhite.vue?vue&type=template&id=1e687f5e&scoped=true&"
import script from "./CreateGiftWhite.vue?vue&type=script&lang=js&"
export * from "./CreateGiftWhite.vue?vue&type=script&lang=js&"
import style0 from "./CreateGiftWhite.vue?vue&type=style&index=0&id=1e687f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e687f5e",
  null
  
)

export default component.exports